import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-confirmation-code-dialog',
  templateUrl: './confirmation-code-dialog.component.html',
})
export class ConfirmationCodeDialogComponent {
  message: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationCodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.message = data.message;
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
